import Vue from "vue";
import Router from "vue-router";
import Store from "store/store";
import event from "plugins/event";
import Routes from "../routes";

Vue.use(Router);

const routes = Routes;

const router = new Router({
    routes: routes
});

// Allowing any element to trigger events
event.$on("route", function(params) {
    router.push(params);
});
event.$on("force-logout", function() {
    Store.commit("user/setAuthentication", null);
    Store.commit("flash/addFlash", {
        type: "error",
        message: router.app.$t("store.message.already-logged-out"),
        onlyNextRoute: true
    });
    let hashtag = undefined;
    try {
        hashtag = window.location.hash;
    }
    // eslint-disable-next-line
    catch(e) {}
    if (hashtag) {
        router.push({
            name: "login",
            query: {
                redirect: hashtag.substr(1)
            }
        });
    } else {
        router.push({
            name: "login",
            query: {
                redirect: hashtag
            }
        });
    }
});

// Authentication checker
router.beforeEach(function checkAuthentication(to, from, next) {
    document.title = router.app.$t("document.title." + to.meta.title) + " | " + process.env.VUE_APP_TITLE;

    // We remove all flash message of the current route.
    Store.commit("flash/removeRouteFlashes");
    // We move all "next state flash" to current one.
    Store.commit("flash/showNextRouteFlashes");


    // If any route requires auth and we are failing to it
    // we redirect to login route.
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (Store.state.user.authentication == null) {
            return next({
                name: "login",
                query: {
                    redirect: to.fullPath
                }
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;